// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --about-bg: #f2f6fc;
  --about-surface: #ffffff;
  --about-surface-soft: #f7fbff;
  --about-text: #11283f;
  --about-muted: #61778f;
  --about-border: #d9e6f3;
  --about-brand: #0f62ad;
  --about-brand-dark: #0a4f8d;
  --about-accent: #f6ba3b;
  --about-shadow-soft: 0 10px 26px rgba(15, 39, 65, 0.08);
  --about-shadow-raise: 0 18px 38px rgba(15, 39, 65, 0.14);
}

.about-container {
  width: min(96%, 1160px);
  margin: 18px auto 0;
  color: var(--about-text);
  line-height: 1.65;
  background:
    radial-gradient(circle at 90% 2%, rgba(188, 215, 240, 0.35) 0%, rgba(188, 215, 240, 0) 33%),
    radial-gradient(circle at 8% 20%, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0) 26%),
    linear-gradient(180deg, #f9fbff 0%, var(--about-bg) 100%);
  border-radius: 24px;
  padding: clamp(18px, 2.8vw, 30px);
  box-sizing: border-box;
}

.about-hero {
  text-align: center;
  color: #ffffff;
  padding: clamp(38px, 7vw, 72px) 20px;
  border-radius: 18px;
  background:
    linear-gradient(130deg, rgba(9, 42, 78, 0.96) 0%, rgba(16, 98, 173, 0.94) 56%, rgba(23, 122, 208, 0.9) 100%);
  box-shadow: var(--about-shadow-raise);
}

.about-hero h1 {
  margin: 0;
  font-size: clamp(2rem, 4vw, 3.1rem);
  letter-spacing: 0.3px;
  color: #ffffff;
}

.about-hero p {
  margin: 14px auto 0;
  max-width: 66ch;
  font-size: clamp(1rem, 1.8vw, 1.2rem);
  color: rgba(240, 247, 255, 0.95);
}

.about-section {
  margin: 18px auto 0;
  padding: 20px;
  max-width: 1000px;
  border-radius: 16px;
  border: 1px solid var(--about-border);
  background: var(--about-surface);
  box-shadow: var(--about-shadow-soft);
}

.about-section h2,
.about-contact h2 {
  margin: 0 0 10px;
  font-size: clamp(1.25rem, 2vw, 1.7rem);
  color: var(--about-text);
  letter-spacing: 0.2px;
}

.about-section p,
.about-contact p {
  margin: 0;
  color: var(--about-muted);
  font-size: 0.98rem;
}

.two-column {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 14px;
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
}

.two-column .box {
  flex: 1 1;
  min-width: 0;
  position: relative;
  overflow: hidden;
  background: var(--about-surface-soft);
  border: 1px solid var(--about-border);
  padding: 22px 20px;
  border-radius: 14px;
  box-shadow: var(--about-shadow-soft);
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.two-column .box::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at top right, rgba(255, 255, 255, 0.45), rgba(255, 255, 255, 0));
  pointer-events: none;
}

.two-column .box::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, var(--about-brand), var(--about-accent));
}

.two-column .box h2 {
  position: relative;
  z-index: 1;
  margin-bottom: 10px;
  font-size: clamp(1.2rem, 2vw, 1.55rem);
}

.two-column .box p {
  position: relative;
  z-index: 1;
  font-size: 0.98rem;
  line-height: 1.7;
}

.two-column .box:hover {
  transform: translateY(-4px);
  box-shadow: var(--about-shadow-raise);
  border-color: #bfd7ee;
}

.about-section ul {
  list-style: none;
  padding: 0;
  margin: 2px 0 0;
  display: grid;
  gap: 10px;
}

.about-section ul li {
  position: relative;
  padding: 10px 12px 10px 36px;
  background: #f4f9ff;
  border: 1px solid var(--about-border);
  border-radius: 10px;
  color: #24435f;
  font-weight: 500;
}

.about-section ul li::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--about-brand), var(--about-accent));
}

.about-contact {
  margin: 18px auto 0;
  text-align: center;
  padding: 26px 20px;
  border-radius: 16px;
  border: 1px solid #c8dcef;
  background:
    linear-gradient(140deg, rgba(12, 80, 141, 0.95) 0%, rgba(16, 98, 173, 0.94) 100%);
  box-shadow: var(--about-shadow-raise);
}

.about-contact h2 {
  color: #ffffff;
}

.about-contact p {
  color: rgba(237, 246, 255, 0.94);
  max-width: 66ch;
  margin: 0 auto;
}

.about-contact button {
  margin-top: 16px;
  background: linear-gradient(120deg, #ffd36a 0%, #f6ba3b 100%);
  color: #103256;
  border: none;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 800;
  border-radius: 999px;
  cursor: pointer;
  letter-spacing: 0.3px;
  transition: transform 0.2s ease, filter 0.2s ease;
}

.about-contact button:hover {
  transform: translateY(-1px);
  filter: brightness(1.05);
}

@media (max-width: 768px) {
  .about-container {
    width: 94%;
    padding: 14px;
    border-radius: 16px;
  }

  .about-hero {
    border-radius: 14px;
    padding: 28px 14px;
  }

  .about-section {
    padding: 15px;
  }

  .two-column {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 10px;
  }

  .about-contact {
    padding: 20px 14px;
  }
}

/* Match shared Footer style with homepage */
.blue-text {
  color: #3391ff;
}

.yellow-text {
  color: #f3bd29;
}

.footer {
  --footer-bg: linear-gradient(140deg, #12283f 0%, #173b5d 52%, #1f4f78 100%);
  --footer-text: #e8f0f8;
  --footer-muted: #c7d5e3;
  --footer-border: rgba(255, 255, 255, 0.14);
  --footer-highlight: #f3bd29;
  margin: 70px 0 -12px;
  padding: 40px clamp(18px, 3vw, 42px) 18px;
  color: var(--footer-text);
  background: var(--footer-bg);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 -18px 42px rgba(8, 29, 47, 0.2);
  box-sizing: border-box;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.footer-main {
  width: min(1240px, 100%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(260px, 1.3fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(220px, 1.1fr);
  gap: clamp(18px, 3vw, 36px);
  align-items: flex-start;
}

.footer-brand-block {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.footer-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.footer-brand img {
  width: 64px;
  height: 64px;
  object-fit: contain;
}

.footer-brand h2 {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: clamp(22px, 2.1vw, 28px);
  letter-spacing: 0.02em;
}

.footer-description {
  margin: 0;
  max-width: 34ch;
  color: var(--footer-muted);
  line-height: 1.65;
  font-size: 14px;
}

.footer-contact-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-contact-list a {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--footer-text);
  text-decoration: none;
  font-size: 14px;
  width: fit-content;
}

.footer-contact-list a:hover {
  color: var(--footer-highlight);
}

.footer-contact-list a svg {
  color: var(--footer-highlight);
  flex-shrink: 0;
}

.footer-link-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-link-group h3,
.footer-social-block h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0.01em;
}

.footer-link-group a {
  color: var(--footer-muted);
  text-decoration: none;
  font-size: 14px;
  width: fit-content;
  transition: color 0.2s ease;
}

.footer-link-group a:hover {
  color: #ffffff;
}

.footer-social-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-social-block p {
  margin: 0;
  color: var(--footer-muted);
  line-height: 1.6;
  font-size: 14px;
}

.footer-social-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(120px, 1fr));
  gap: 10px;
}

.footer-social-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 42px;
  border: 1px solid var(--footer-border);
  border-radius: 999px;
  color: #ffffff;
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.06);
  transition:
    transform 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.footer-social-item:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.26);
}

.footer-bottom {
  width: min(1240px, 100%);
  margin: 28px auto 0;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  color: var(--footer-muted);
  font-size: 13px;
}

.footer-bottom-links {
  display: flex;
  align-items: center;
  gap: 16px;
}

.footer-bottom-links a {
  color: var(--footer-muted);
  text-decoration: none;
}

.footer-bottom-links a:hover {
  color: #ffffff;
}

@media screen and (max-width: 1080px) {
  .footer-main {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }
}

@media screen and (max-width: 768px) {
  .footer {
    margin-top: 48px;
    padding: 30px 16px 90px;
  }

  .footer-main {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .footer-social-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
    font-size: 12px;
  }

  .footer-bottom-links {
    gap: 12px;
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AboutusPage/about.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,uDAAuD;EACvD,wDAAwD;AAC1D;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB;;;6DAG2D;EAC3D,mBAAmB;EACnB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB;gHAC8G;EAC9G,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;;EAEE,gBAAgB;EAChB,sCAAsC;EACtC,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;EAEE,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,gFAAgF;AAClF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mGAAmG;EACnG,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,WAAW;EACX,2EAA2E;AAC7E;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB;qFACmF;EACnF,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,4CAA4C;AAC5C;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2EAA2E;EAC3E,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;EAC1C,2BAA2B;EAC3B,oBAAoB;EACpB,yCAAyC;EACzC,yBAAyB;EACzB,4BAA4B;EAC5B,+CAA+C;EAC/C,6CAA6C;EAC7C,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,sGAAsG;EACtG,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,sCAAsC;EACtC,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC;;;0BAGwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;AACF","sourcesContent":[":root {\n  --about-bg: #f2f6fc;\n  --about-surface: #ffffff;\n  --about-surface-soft: #f7fbff;\n  --about-text: #11283f;\n  --about-muted: #61778f;\n  --about-border: #d9e6f3;\n  --about-brand: #0f62ad;\n  --about-brand-dark: #0a4f8d;\n  --about-accent: #f6ba3b;\n  --about-shadow-soft: 0 10px 26px rgba(15, 39, 65, 0.08);\n  --about-shadow-raise: 0 18px 38px rgba(15, 39, 65, 0.14);\n}\n\n.about-container {\n  width: min(96%, 1160px);\n  margin: 18px auto 0;\n  color: var(--about-text);\n  line-height: 1.65;\n  background:\n    radial-gradient(circle at 90% 2%, rgba(188, 215, 240, 0.35) 0%, rgba(188, 215, 240, 0) 33%),\n    radial-gradient(circle at 8% 20%, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0) 26%),\n    linear-gradient(180deg, #f9fbff 0%, var(--about-bg) 100%);\n  border-radius: 24px;\n  padding: clamp(18px, 2.8vw, 30px);\n  box-sizing: border-box;\n}\n\n.about-hero {\n  text-align: center;\n  color: #ffffff;\n  padding: clamp(38px, 7vw, 72px) 20px;\n  border-radius: 18px;\n  background:\n    linear-gradient(130deg, rgba(9, 42, 78, 0.96) 0%, rgba(16, 98, 173, 0.94) 56%, rgba(23, 122, 208, 0.9) 100%);\n  box-shadow: var(--about-shadow-raise);\n}\n\n.about-hero h1 {\n  margin: 0;\n  font-size: clamp(2rem, 4vw, 3.1rem);\n  letter-spacing: 0.3px;\n  color: #ffffff;\n}\n\n.about-hero p {\n  margin: 14px auto 0;\n  max-width: 66ch;\n  font-size: clamp(1rem, 1.8vw, 1.2rem);\n  color: rgba(240, 247, 255, 0.95);\n}\n\n.about-section {\n  margin: 18px auto 0;\n  padding: 20px;\n  max-width: 1000px;\n  border-radius: 16px;\n  border: 1px solid var(--about-border);\n  background: var(--about-surface);\n  box-shadow: var(--about-shadow-soft);\n}\n\n.about-section h2,\n.about-contact h2 {\n  margin: 0 0 10px;\n  font-size: clamp(1.25rem, 2vw, 1.7rem);\n  color: var(--about-text);\n  letter-spacing: 0.2px;\n}\n\n.about-section p,\n.about-contact p {\n  margin: 0;\n  color: var(--about-muted);\n  font-size: 0.98rem;\n}\n\n.two-column {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 14px;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n}\n\n.two-column .box {\n  flex: 1 1 0;\n  min-width: 0;\n  position: relative;\n  overflow: hidden;\n  background: var(--about-surface-soft);\n  border: 1px solid var(--about-border);\n  padding: 22px 20px;\n  border-radius: 14px;\n  box-shadow: var(--about-shadow-soft);\n  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;\n}\n\n.two-column .box::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at top right, rgba(255, 255, 255, 0.45), rgba(255, 255, 255, 0));\n  pointer-events: none;\n}\n\n.two-column .box::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, var(--about-brand), var(--about-accent));\n}\n\n.two-column .box h2 {\n  position: relative;\n  z-index: 1;\n  margin-bottom: 10px;\n  font-size: clamp(1.2rem, 2vw, 1.55rem);\n}\n\n.two-column .box p {\n  position: relative;\n  z-index: 1;\n  font-size: 0.98rem;\n  line-height: 1.7;\n}\n\n.two-column .box:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--about-shadow-raise);\n  border-color: #bfd7ee;\n}\n\n.about-section ul {\n  list-style: none;\n  padding: 0;\n  margin: 2px 0 0;\n  display: grid;\n  gap: 10px;\n}\n\n.about-section ul li {\n  position: relative;\n  padding: 10px 12px 10px 36px;\n  background: #f4f9ff;\n  border: 1px solid var(--about-border);\n  border-radius: 10px;\n  color: #24435f;\n  font-weight: 500;\n}\n\n.about-section ul li::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 14px;\n  transform: translateY(-50%);\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--about-brand), var(--about-accent));\n}\n\n.about-contact {\n  margin: 18px auto 0;\n  text-align: center;\n  padding: 26px 20px;\n  border-radius: 16px;\n  border: 1px solid #c8dcef;\n  background:\n    linear-gradient(140deg, rgba(12, 80, 141, 0.95) 0%, rgba(16, 98, 173, 0.94) 100%);\n  box-shadow: var(--about-shadow-raise);\n}\n\n.about-contact h2 {\n  color: #ffffff;\n}\n\n.about-contact p {\n  color: rgba(237, 246, 255, 0.94);\n  max-width: 66ch;\n  margin: 0 auto;\n}\n\n.about-contact button {\n  margin-top: 16px;\n  background: linear-gradient(120deg, #ffd36a 0%, #f6ba3b 100%);\n  color: #103256;\n  border: none;\n  padding: 12px 24px;\n  font-size: 14px;\n  font-weight: 800;\n  border-radius: 999px;\n  cursor: pointer;\n  letter-spacing: 0.3px;\n  transition: transform 0.2s ease, filter 0.2s ease;\n}\n\n.about-contact button:hover {\n  transform: translateY(-1px);\n  filter: brightness(1.05);\n}\n\n@media (max-width: 768px) {\n  .about-container {\n    width: 94%;\n    padding: 14px;\n    border-radius: 16px;\n  }\n\n  .about-hero {\n    border-radius: 14px;\n    padding: 28px 14px;\n  }\n\n  .about-section {\n    padding: 15px;\n  }\n\n  .two-column {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    gap: 10px;\n  }\n\n  .about-contact {\n    padding: 20px 14px;\n  }\n}\n\n/* Match shared Footer style with homepage */\n.blue-text {\n  color: #3391ff;\n}\n\n.yellow-text {\n  color: #f3bd29;\n}\n\n.footer {\n  --footer-bg: linear-gradient(140deg, #12283f 0%, #173b5d 52%, #1f4f78 100%);\n  --footer-text: #e8f0f8;\n  --footer-muted: #c7d5e3;\n  --footer-border: rgba(255, 255, 255, 0.14);\n  --footer-highlight: #f3bd29;\n  margin: 70px 0 -12px;\n  padding: 40px clamp(18px, 3vw, 42px) 18px;\n  color: var(--footer-text);\n  background: var(--footer-bg);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 -18px 42px rgba(8, 29, 47, 0.2);\n  box-sizing: border-box;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.footer-main {\n  width: min(1240px, 100%);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(260px, 1.3fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(220px, 1.1fr);\n  gap: clamp(18px, 3vw, 36px);\n  align-items: flex-start;\n}\n\n.footer-brand-block {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.footer-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n}\n\n.footer-brand img {\n  width: 64px;\n  height: 64px;\n  object-fit: contain;\n}\n\n.footer-brand h2 {\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: clamp(22px, 2.1vw, 28px);\n  letter-spacing: 0.02em;\n}\n\n.footer-description {\n  margin: 0;\n  max-width: 34ch;\n  color: var(--footer-muted);\n  line-height: 1.65;\n  font-size: 14px;\n}\n\n.footer-contact-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.footer-contact-list a {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--footer-text);\n  text-decoration: none;\n  font-size: 14px;\n  width: fit-content;\n}\n\n.footer-contact-list a:hover {\n  color: var(--footer-highlight);\n}\n\n.footer-contact-list a svg {\n  color: var(--footer-highlight);\n  flex-shrink: 0;\n}\n\n.footer-link-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.footer-link-group h3,\n.footer-social-block h3 {\n  margin: 0 0 8px;\n  font-size: 18px;\n  color: #ffffff;\n  letter-spacing: 0.01em;\n}\n\n.footer-link-group a {\n  color: var(--footer-muted);\n  text-decoration: none;\n  font-size: 14px;\n  width: fit-content;\n  transition: color 0.2s ease;\n}\n\n.footer-link-group a:hover {\n  color: #ffffff;\n}\n\n.footer-social-block {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.footer-social-block p {\n  margin: 0;\n  color: var(--footer-muted);\n  line-height: 1.6;\n  font-size: 14px;\n}\n\n.footer-social-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(120px, 1fr));\n  gap: 10px;\n}\n\n.footer-social-item {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 42px;\n  border: 1px solid var(--footer-border);\n  border-radius: 999px;\n  color: #ffffff;\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 600;\n  background: rgba(255, 255, 255, 0.06);\n  transition:\n    transform 0.2s ease,\n    background-color 0.2s ease,\n    border-color 0.2s ease;\n}\n\n.footer-social-item:hover {\n  transform: translateY(-2px);\n  background: rgba(255, 255, 255, 0.14);\n  border-color: rgba(255, 255, 255, 0.26);\n}\n\n.footer-bottom {\n  width: min(1240px, 100%);\n  margin: 28px auto 0;\n  padding-top: 14px;\n  border-top: 1px solid rgba(255, 255, 255, 0.16);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  color: var(--footer-muted);\n  font-size: 13px;\n}\n\n.footer-bottom-links {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.footer-bottom-links a {\n  color: var(--footer-muted);\n  text-decoration: none;\n}\n\n.footer-bottom-links a:hover {\n  color: #ffffff;\n}\n\n@media screen and (max-width: 1080px) {\n  .footer-main {\n    grid-template-columns: repeat(2, minmax(220px, 1fr));\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .footer {\n    margin-top: 48px;\n    padding: 30px 16px 90px;\n  }\n\n  .footer-main {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .footer-social-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .footer-bottom {\n    flex-direction: column;\n    align-items: flex-start;\n    font-size: 12px;\n  }\n\n  .footer-bottom-links {\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
